/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableForAllocationBinderOptionDto
 */
export interface AvailableForAllocationBinderOptionDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationBinderOptionDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationBinderOptionDto
     */
    binderName: string;
}

/**
 * Check if a given object implements the AvailableForAllocationBinderOptionDto interface.
 */
export function instanceOfAvailableForAllocationBinderOptionDto(value: object): value is AvailableForAllocationBinderOptionDto {
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('binderName' in value) || value['binderName'] === undefined) return false;
    return true;
}

export function AvailableForAllocationBinderOptionDtoFromJSON(json: any): AvailableForAllocationBinderOptionDto {
    return AvailableForAllocationBinderOptionDtoFromJSONTyped(json, false);
}

export function AvailableForAllocationBinderOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableForAllocationBinderOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'binderId': json['binderId'],
        'binderName': json['binderName'],
    };
}

export function AvailableForAllocationBinderOptionDtoToJSON(json: any): AvailableForAllocationBinderOptionDto {
    return AvailableForAllocationBinderOptionDtoToJSONTyped(json, false);
}

export function AvailableForAllocationBinderOptionDtoToJSONTyped(value?: AvailableForAllocationBinderOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'binderId': value['binderId'],
        'binderName': value['binderName'],
    };
}

